// Double taps are detected from two plain `click` events instead of
// `dblclick` — iOS Safari doesn't reliably synthesize `dblclick` on
// non-interactive elements, while `click` always fires. 300ms is iOS's
// historical double-tap window; desktop double-clicks land well inside it.
// Both taps must land near each other so two unrelated taps (e.g. while
// panning attention across the element) don't count as one gesture.
const DOUBLE_TAP_MS = 300;
const DOUBLE_TAP_SLOP_PX = 40;

export class DoubleTapTracker {
  private _lastTime = 0;
  private _lastX = 0;
  private _lastY = 0;

  /** Feed every `click` event; returns true when it completes a double tap. */
  isDoubleTap(event: MouseEvent): boolean {
    // Keyboard-synthesized clicks carry detail 0 and have no meaningful
    // coordinates — never count them toward a double tap.
    if (event.detail === 0) {
      return false;
    }
    const isDouble =
      event.timeStamp - this._lastTime <= DOUBLE_TAP_MS &&
      Math.abs(event.clientX - this._lastX) + Math.abs(event.clientY - this._lastY) <=
        DOUBLE_TAP_SLOP_PX;
    if (isDouble) {
      // Reset so a triple tap completes one gesture instead of two.
      this._lastTime = 0;
      return true;
    }
    this._lastTime = event.timeStamp;
    this._lastX = event.clientX;
    this._lastY = event.clientY;
    return false;
  }
}
